import LpuFilial from "../types/models/lpu-filial";

export const getFilialPhones = (filial: LpuFilial) => {
  const phones = [];
  if (filial.filialPhone) phones.push(filial.filialPhone);
  if (filial.filialPhone2) phones.push(filial.filialPhone2);
  return phones;
};
